<template>
  <ul class="exhibitions_list">
    <template v-for="item in list">
      <exhibitions_list_item :objItem="item" :type="type"/>
    </template>
  </ul>
</template>

<script>
import exhibitions_list_item from "./exhibitions_list_item";
export default {
  components: {
    exhibitions_list_item
  },
  props:{
    list: Array,
    type: {
      type: String,
      default: 'def'
    }
  },
  data(){
    return{

    }
  },
  methods:{

  }
};
</script>

<style lang="scss" scoped>
.exhibitions_list {
  display: flex;
  flex-wrap: wrap;
  .exhibitions_list_item:nth-of-type(3n) {
    margin-right: 0;
  }
  // .exhibitions_list_item:nth-of-type(n + 3) {
  //   margin-bottom: 0;
  // }
}
</style>
